module.exports = __webpack_public_path__ + "static/img/100tgimg.d501303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/100tgimg.jpg
// module id = cIBO
// module chunks = 2